
import React, { useState, useEffect } from 'react'
import cl from 'classnames'
import styles from './CheckBoxes.module.scss'
import { observer } from 'mobx-react-lite'
import { inject } from 'mobx-react'

import { PROJECT_STORE, BRAND_STORE } from 'store'
import { toJS } from 'mobx'
import BranchContainer from './BranchContainer'
import { CheckBoxesProps } from './CheckBoxes.types'
import CheckBoxLine from './BranchContainer/CheckBoxLine'
import { SelectedObjectTag } from './SelectedObjectTag'
import { FilterTypes } from 'models'

const CheckBoxes = (props: CheckBoxesProps) => {
  const {
    [PROJECT_STORE]: { projectsList, getProjects },
    [BRAND_STORE]: { brandsList, getBrands },
    store,
    filter,
    setFilterProp
  } = props

  const [objects, setObjects] = useState([])
  const [showList, setShowList] = useState(false)

  useEffect(() => {
    store === 'projects'
      ? getProjects(true)
      : getBrands(true)
  }, [getProjects, getBrands, store])

  useEffect(() => {
    const filterBrandsList = () => {
      return filter.type === FilterTypes.PRODUCTS
        ? toJS(brandsList).filter(brand => (brand.products && brand.products.length))
        : toJS(brandsList)
    }

    store === 'projects'
      ? setObjects(toJS(projectsList))
      : setObjects(filterBrandsList())
  }, [projectsList, brandsList, store, filter.type])

  // console.log('objects', objects);

  const getSelectedObjects = () => {
    if (store !== 'brands' || filter.type === FilterTypes.BRANDS) {
      return filter[store]
    }

    return filter.products
  }

  const wrapperObject = {
    id: 'all',
    name: 'All',
    children: objects,
    products: objects
  }

  const selectedObjects = getSelectedObjects()

  const deselectObject = (objectId: number) => () => {
    let newSelectedObjects = [...selectedObjects]

    newSelectedObjects = newSelectedObjects.filter(obj => obj.id !== objectId)

    const filterPropertyKey = filter.type === FilterTypes.PRODUCTS
      ? 'products'
      : store

    setFilterProp({ [filterPropertyKey]: newSelectedObjects })
  }

  return (
    <div className={styles.container}>
      <div className={styles.tagsContainer}>
        <CheckBoxLine
          store={store}
          object={wrapperObject}
          selectedObjects={selectedObjects}
          filterType={filter.type}
          setFilterProp={setFilterProp}
          subObjectLevel={0}
          childPropertyName={store === 'projects' ? 'children' : 'products'}
          expandable={true}
          expanded={showList}
          onClick={() => setShowList(!showList)}
        />
        {(selectedObjects as any[]).map(object => {
          if (object.id === 'all') return null
          return (
            <SelectedObjectTag
              key={object.id}
              object={object}
              onCloseClick={deselectObject(object.id)}
            />
          )
        })}
      </div>
      {showList && <div className={cl(styles.checkBoxes, styles.scrollable)}>
        {objects.map(object =>
          <BranchContainer
            key={object.id}
            object={object}
            selectedObjects={selectedObjects}
            store={store}
            setFilterProp={setFilterProp}
            filterType={filter.type}
          />
        )}
      </div>}
    </div>
  )
}

export default inject(PROJECT_STORE, BRAND_STORE)(observer(CheckBoxes))
